module.exports = __webpack_public_path__ + "media/site/images/products/ekanban-flat-screen2-941f46bf2bc824c1d2416b127a1445be.png";